import { render, staticRenderFns } from "./ListaCliente.vue?vue&type=template&id=fc1b6c00"
import script from "./ListaCliente.vue?vue&type=script&lang=js"
export * from "./ListaCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports